import PortalIdParser from 'PortalIdParser';
import { ThumbnailSizes } from '../constants';
import { appendStaticAppInfo, getApiHostForEnvironment } from '../internal/utils';
export function getThumbnailUrl(fileId, thumbSize = ThumbnailSizes.THUMB, isFilePrivate = false) {
  let path = `//${getApiHostForEnvironment()}/filemanager/api/v3/files/thumbnail-redirect/${fileId}`;
  if (isFilePrivate) {
    path = `//${getApiHostForEnvironment()}/filemanager/api/v2/files/${fileId}/signed-url-redirect`;
  }
  const url = `${path}?size=${thumbSize}&portalId=${PortalIdParser.get()}`;
  return appendStaticAppInfo(url);
}